<template>
  <v-menu close-on-content-click :max-width="250" :nudge-width="100" offset-x close-on-click right>
    <template v-slot:activator="{ on }">
      <!-- <v-avatar color="blue-grey lighten-4" v-on="on">
        <v-icondark>mdi-account</v-icondark>
      </v-avatar>-->
      <v-avatar size="32px" item v-on="on">
        <v-img src="https://cdn.vuetifyjs.com/images/logos/logo.svg" alt="Vuetify" />
      </v-avatar>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <span class="h2 mb-1 blue-grey--text">{{ AuthUser.first_name }}</span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <span class="h2 mb-1 blue-grey--text">{{ AuthUser.email }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-0 py-0"></v-divider>

      <v-list dense>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-location-exit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title @click="logout">Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  computed: {
    AuthUser() {
      return this.$store.getters["auth/AUTH_USER"];
    }
  },

  methods: {
    logout() {
      this.$store.dispatch("auth/LOGOUT");
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
</style>